import { render, staticRenderFns } from "./parentTaskList.vue?vue&type=template&id=adc53aa2&scoped=true&"
import script from "./parentTaskList.vue?vue&type=script&lang=js&"
export * from "./parentTaskList.vue?vue&type=script&lang=js&"
import style0 from "./parentTaskList.vue?vue&type=style&index=0&id=adc53aa2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adc53aa2",
  null
  
)

export default component.exports